import Endpoint from '../Endpoint'

export default class Auth extends Endpoint {
  getToken(username, password) {
    return this.client.request(
      {
        method: 'POST',
        endpoint: '/oauth2/token/',
        data: {
          client_id: this.client.clientId,
          grant_type: 'password',
          username,
          password,
        },
      },
      false,
    )
  }

  refreshToken() {
    const refreshToken = this.client.getRefreshToken()
    if (refreshToken == null) {
      return Promise.reject(new Error('No valid refresh token found.'))
    }
    return this.client.request(
      {
        method: 'POST',
        endpoint: '/oauth2/token/',
        data: {
          client_id: this.client.clientId,
          grant_type: 'refresh_token',
          refresh_token: refreshToken,
        },
      },
      false,
    )
  }

  revokeToken(accessToken) {
    return this.client.request({
      method: 'POST',
      endpoint: '/oauth2/revoke_token/',
      data: {
        client_id: this.client.clientId,
        token: accessToken,
      },
    })
  }
}



// WEBPACK FOOTER //
// ../source/api/endpoints/Auth.js